import React from 'react';
import { Upload, Users, BarChart3, Settings } from 'lucide-react';
import { Card } from '../common/Card';
import { Button } from '../common/Button';

interface QuickActionsProps {
  onTabChange: (tab: string) => void;
}

export const QuickActions: React.FC<QuickActionsProps> = ({ onTabChange }) => {
  const actions = [
    {
      id: 'distribute',
      label: 'Distribute New Song',
      description: 'Upload and distribute your latest track',
      icon: Upload,
      color: 'primary' as const
    },
    {
      id: 'artists',
      label: 'Manage Artists',
      description: 'Add or edit artist profiles',
      icon: Users,
      color: 'secondary' as const
    },
    {
      id: 'analytics',
      label: 'View Analytics',
      description: 'Check your performance metrics',
      icon: BarChart3,
      color: 'outline' as const
    },
    {
      id: 'settings',
      label: 'Account Settings',
      description: 'Update your preferences',
      icon: Settings,
      color: 'ghost' as const
    }
  ];
  
  return (
    <Card>
      <h3 className="text-lg font-semibold text-white font-display mb-6">Quick Actions</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {actions.map((action) => (
          <button
            key={action.id}
            onClick={() => onTabChange(action.id)}
            className="p-4 text-left border border-gray-700 rounded-lg hover:border-gold-500/50 hover:bg-gray-800/50 transition-all group"
          >
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-gold-500/10 text-gold-400 rounded-lg group-hover:bg-gold-500/20">
                <action.icon className="w-5 h-5" />
              </div>
              <div>
                <p className="font-medium text-white group-hover:text-gold-400 transition-colors">
                  {action.label}
                </p>
                <p className="text-sm text-gray-400 mt-1">
                  {action.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </Card>
  );
};